"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWithVowel = exports.capitalize = void 0;
const capitalize = (s) => s && s.charAt(0).toUpperCase() + s.slice(1);
exports.capitalize = capitalize;
const startsWithVowel = (s, additional = []) => {
    const upperCaseChars = additional.map(element => {
        return element.toUpperCase();
    });
    // Not including Y on purpose since it is a semi-vowel and isn't considered a vowel when used at the beginning of a word.
    return s && (['A', 'E', 'I', 'O', 'U'].concat(upperCaseChars)).includes(s.charAt(0).toUpperCase());
};
exports.startsWithVowel = startsWithVowel;
//# sourceMappingURL=strings.js.map